module.exports = __webpack_public_path__ + "img/cnh.ea5372da.jpg";